import { RecursoFiltro } from 'app/entity/recurso-filtro.model';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { BaseStepComponent } from '../../../base';
import { SelectItem } from 'primeng/primeng';


@Component({
    selector: 'gerenciamento-banca-etapa1',
    templateUrl: './etapa1.component.html'
})
export class GerenciarBancaEtapa1Component extends BaseStepComponent {

    @Input("Anexos") listaAnexos: any[];
    @Input() listaDadosInstituicao: SelectItem[];
    @Input() listaTipoAtividade: SelectItem[];
    @Input() listaResumo: any[];
    @Input() listaRelatores: any[];
    @Input() validateForm: any = false;
    @Input() mostrarCodigo: boolean;
    @Output() listaAnexoChange = new EventEmitter<any>();
    @Output() carregarObj = new EventEmitter<any>();
    @Output() stepObject: EventEmitter<any> = new EventEmitter<any>(true);
    @Output() validateFormChange = new EventEmitter<any>();
    @Input() cpf: string;
    @Input() justificativa;
    @Input() recursoFiltro: RecursoFiltro;
    userInteracted = false;

    @Input() listaCapacitadora: any[] = [];
    init() {
        this.listaAnexoChange.emit(this.listaAnexos);
        this.stepObject.emit(this);
        this.emitValidation(true);
    }
    emitValidation(isInit = false) {
        if (isInit) {
            this.validateForm = [];
        } else {
            let countListaArquivos = this.listaAnexos.length;
            if (this.cadastro.valid && countListaArquivos > 0) {
                this.isValid = true;
                this.carregarObj.emit(this.cadastro);
            }
            else {
                this.isValid = false;
                this.validateForm = [this.cadastro];
                if (countListaArquivos == 0) {
                    this.showMsgWarn(`<p>O anexo de arquivos é obrigatório.<br><br> Todos os arquivos deverão ser anexados de uma só vez.</p>`);
                }
                else if (!this.cadastro.valid) {
                    this.cadastro.markAsTouched();
                }
            }
        }
        setTimeout(() => this.validateFormChange.emit(this.validateForm), 0);
        this.isValidChange.emit(this.isValid);
    }

    onCalendarInteraction() {
        this.userInteracted = true;
    }
    onDataFimChange(event: any) {
        if (this.userInteracted) {
            this.cadastro.get('id_natureza').setValue(null);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/gerenciamento-banca/crud/etapa1/etapa1.component.ts